// extracted by mini-css-extract-plugin
module.exports = {"header-image":"_Layout_header-image_20gyF","layout-size":"_Layout_layout-size_FluaN","layout-color":"_Layout_layout-color_8gbAo","terms":"_Layout_terms_kfwtC"};